window.openModal = function (target) {
  document.querySelector('body').classList.add('od-modal-open');
  document.querySelector(target).classList.add('open');
  document.querySelector(target).setAttribute('aria-hidden','false');
  // prevent scrolling on ios safari
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}`;
}

//close modal
window.closeModals = function () {
  document.querySelector('body').classList.remove('od-modal-open');
  const modals = document.querySelectorAll('.info-modal');
  for (let i = 0; i < modals.length; i++) {
    modals[i].classList.remove('open');
    modals[i].setAttribute('aria-hidden','true');
  }
  // maintain scroll position and removing 'fixed' scrolling on ios safari
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

$(document).on("click", '.info-modal', function(e){
  if(e.target.classList.contains('info-modal') || !!$(e.target).parents('.modal-block__close').length) {
    window.closeModals()
  }
})